module.exports = __webpack_public_path__ + "img/date.d5c48b8f.svg";